/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapRegion', {
                bindings: {
                    mode: '<',
                    model: '<',
                    onModeChanged: '&',
                    onRegionChanged: '&',
                    onModelReset: '&',
                    onStateRemoved: '&'
                },
                templateUrl: 'app/region/dashboard/region/region.component.html',
                controller: regionComponentController,
                controllerAs: 'vm'
            });

    /* @ngInject */
    function regionComponentController(logger, currentUser, regionService, dialogService) {
        this.$onChanges = onChanges;

        var vm = this;

        vm.originalRegions = [];
        vm.regions = [];
        vm.selection = {};
        vm.selectedRegion = {};

        // public methods
        vm.clear = clear;
        vm.save = saveRegion;
        vm.delete = deleteRegion;

        vm.changeToCreateMode = changeToCreateMode;
        vm.regionSelectionChange = regionSelectionChange;

        function onChanges(changes) {
            if (changes.mode && changes.mode.currentValue.isEdit) {
                getRegions(vm.model.corporateid);
            }

            if (changes.model && changes.model.currentValue.corporateid !== changes.model.previousValue.corporateid) {
                if (vm.mode.isEdit) {
                    getRegions(changes.model.currentValue.corporateid);
                }
            }
        }

        function clear() {
            if (vm.mode.isCreate) {
                vm.onModelReset();
            } else {
                regionSelectionChange(vm.selectedRegion);
            }
        }

        function reloadRegions() {
            getRegions(vm.model.corporateid);
        }

        function changeToCreateMode() {
            vm.mode.isEdit = false;
            vm.mode.isCreate = true;
            vm.onModeChanged({ mode: vm.mode});
        }

        function regionSelectionChange(region) {
            vm.selectedRegion = angular.copy(region);
            vm.model = angular.copy(region);
            vm.onRegionChanged({ region: region });
        }

        function getRegions(corporateId) {
            regionService.getRegions(corporateId, currentUser).then(function (result) {
                if (result.length > 0) {
                    vm.regions = result;
                    regionSelectionChange(result[0]);
                } else {
                    vm.regions = [];
                    resetModel();
                }
            });
        }

        function resetModel() {
            var corporateid = vm.model.corporateid;
            vm.model = regionService.getDefaultRegionModel();
            vm.model.corporateid = corporateid;
            vm.onRegionChanged({ region: vm.model });
        }

        function saveRegion() {
            if (!!vm.model.id) {
                dialogService.confirm('Update Region',
                        'Are you sure you want to update changes to this region?')
                    .then(function () {
                        return regionService.saveRegion(vm.model);
                    }).then(function (result) {
                        onSaveandDeleteRegion(result, 'update');
                    });
            } else {
                regionService.saveRegion(vm.model)
                    .then(function (result) {
                        onSaveandDeleteRegion(result, 'save');
                    });
            }
        }

        function deleteRegion() {
            dialogService.confirm('Delete Region',
                    'Are you sure you want to delete this region?')
                .then(function () {
                    return regionService.deleteRegion(vm.model);
                }).then(function (result) {
                    onSaveandDeleteRegion(result, 'delete');
                });
        }

        function onSaveandDeleteRegion(result, currentOperation) {
            if (result.status === 200) {
                logger.info('Region successfully ' + currentOperation + 'd');
                if (currentOperation === 'save') {
                    vm.onModelReset();
                } else {
                    reloadRegions();
                }
            } else if (result.status === 204) {
                logger.error('Error has occured. Please contact System Administrator.');
            }
        }
    }
})();
